<template>
    <router-view />
</template>

<script>
import User from "@2kog/pkg-common/utils/user";
import { mapMutations } from "vuex";
import { getStaticConfig } from "@/service/system";
export default {
    name: "App",
    props: [],
    components: {},
    data: function () {
        return {};
    },
    watch: {},
    methods: {
        ...mapMutations({
            setApp: "SET_APP",
            setLang: "SET_LOCALE",
        }),
        checkTokenVersion() {
            // 获取staticConfig后，检查token版本，与localStorage中的版本号对比，不一致则清除登录状态
            const tokenVersion = localStorage.getItem("token_version");
            getStaticConfig().then((config) => {
                if (config.token_version && config.token_version !== tokenVersion) {
                    User.logout();
                    localStorage.setItem("token_version", config.token_version);
                    this.$router.replace({ name: "account-login" });
                }
            });
        },
    },
    created: function () {
        // 生成特征码
        User.generateFingerprint();
        // 检查token版本
        this.checkTokenVersion();
    },
    mounted: function () {
        // 多语言
        if (User.isLogin()) {
            this.$store.dispatch("getProfile").then((res) => {
                if (res.lang && User.getLocale() !== res.lang) {
                    User.setLocale(res.lang);
                    location.reload();
                } else if (!res.lang && User.getLocale() !== "en-US") {
                    User.setLocale("en-US");
                    location.reload();
                }
            });
        } else {
            const lang = navigator.language || navigator.userLanguage;
            if (lang && User.getLocale() !== lang) {
                User.setLocale(lang);
                this.setLang(lang);
            }
        }

        // App
        const search = new URLSearchParams(document.location.search);
        if (search.has("app")) {
            const app = search.get("app");
            sessionStorage.setItem("app", search.get("app"));
            this.setApp(app);
        }
    },
};
</script>

<style lang="less">
@import "@/assets/css/app.less";
</style>
